import { useContext } from 'react'

import ProductPageContext, { productContextInitialState } from '../contexts/ProductPageContext'

const useProductPageContext = () => {
  const context = useContext(ProductPageContext) ?? productContextInitialState
  return context
}

export default useProductPageContext
